import {Permission, Permissions} from "./resources";

interface InternalPermission {
    projectIds: string[];
    environmentIds: string[];
    projectGroupIds: string[];
    tenantIds: string[];
}

interface InternalPermissions {
    [name: string]: InternalPermission[];
}

interface Authorization {
    permission: Permission;
    projectId?: string;
    environmentId?: string;
    projectGroupId?: string;
    tenantId?: string;
}

export class UserPermissions {
    private internalPermissions: InternalPermissions;

    constructor(permissions: Permissions) {
        const ps: InternalPermissions = {};
        Object.keys(permissions).forEach((k) => {
            ps[k.toLowerCase()] = permissions[k].map((e: any) => {
                return {
                    projectIds: (e.RestrictedToProjectIds || []).map((id: string) => id.toLowerCase()),
                    environmentIds: (e.RestrictedToEnvironmentIds || []).map((id: string) => id.toLowerCase()),
                    projectGroupIds: (e.RestrictedToProjectGroupIds || []).map((id: string) => id.toLowerCase()),
                    tenantIds: (e.RestrictedToTenantIds || []).map((id: string) => id.toLowerCase())
                };
            });
        });
        this.internalPermissions = ps;
    }

    firstAuthorized(permissions: Permission[]): Permission {
        let match: any = null;

        permissions.forEach((p) => {
            const restrictions = this.internalPermissions[p.toLowerCase()];

            if (!restrictions) {
                return;
            }

            if (!match) {
                match = p;
            }
        });

        return match;
    }

    isAuthorized(authorization: Authorization): boolean {
        const isWildcard = (s: string) => {
            return s === "*";
        };

        const restrictions = this.internalPermissions[authorization.permission.toLowerCase()];
        if (!restrictions) {
            // User doesn't have the permission in any scope
            return false;
        }

        if (restrictions.length === 0) {
            // No restrictions
            return true;
        }

        for (const restriction of restrictions) {
            let allowed = true;

            if (restriction.projectIds.length !== 0) {
                if (authorization.projectId == null ||
                    (!isWildcard(authorization.projectId) && !restriction.projectIds.includes(authorization.projectId.toLowerCase()))) {
                    allowed = false;
                }
            }

            if (restriction.environmentIds.length !== 0) {
                if (authorization.environmentId == null ||
                    (!isWildcard(authorization.environmentId) && !restriction.environmentIds.includes(authorization.environmentId.toLowerCase()))) {
                    allowed = false;
                }
            }

            if (restriction.projectGroupIds.length !== 0) {
                if (authorization.projectGroupId == null ||
                    (!isWildcard(authorization.projectGroupId) && !restriction.projectGroupIds.includes(authorization.projectGroupId.toLowerCase()))) {
                    allowed = false;
                }
            }

            if (restriction.tenantIds.length !== 0) {
                if (authorization.tenantId == null ||
                    (!isWildcard(authorization.tenantId) && !restriction.tenantIds.includes(authorization.tenantId.toLowerCase()))) {
                    allowed = false;
                }
            }

            if (allowed) {
                return true;
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/userPermissions.ts